import React from "react";
import GatewayDoARPage from "./GatewayDoARPage";

// ToDoAR owns its continuation actions directly. Keeping this file as the
// route-level compatibility entry avoids a second DOM/AR owner and preserves
// existing imports while the gateway itself performs canonical DoAR handoffs.
export default function GatewayPage() {
  return <GatewayDoARPage />;
}

export * from "./GatewayDoARPage";
